export default {
 apiURI: 'https://tpv.colorimpreso.com',
 defaultSaleMode: true,
 defaultCashMode: true
}



// WEBPACK FOOTER //
// ./src/config.js